export const StopIcon = ({ className }) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.25 13.5H3.75C3.41848 13.5 3.10054 13.3683 2.86612 13.1339C2.6317 12.8995 2.5 12.5815 2.5 12.25V3.75C2.5 3.41848 2.6317 3.10054 2.86612 2.86612C3.10054 2.6317 3.41848 2.5 3.75 2.5H12.25C12.5815 2.5 12.8995 2.6317 13.1339 2.86612C13.3683 3.10054 13.5 3.41848 13.5 3.75V12.25C13.5 12.5815 13.3683 12.8995 13.1339 13.1339C12.8995 13.3683 12.5815 13.5 12.25 13.5Z"
      fill="currentColor"
    />
  </svg>
);

export const PauzeIcon = ({ className }) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M6.5 13.5H5C4.86739 13.5 4.74021 13.4473 4.64645 13.3536C4.55268 13.2598 4.5 13.1326 4.5 13V3C4.5 2.86739 4.55268 2.74021 4.64645 2.64645C4.74021 2.55268 4.86739 2.5 5 2.5H6.5C6.63261 2.5 6.75979 2.55268 6.85355 2.64645C6.94732 2.74021 7 2.86739 7 3V13C7 13.1326 6.94732 13.2598 6.85355 13.3536C6.75979 13.4473 6.63261 13.5 6.5 13.5Z"
      fill="currentColor"
    />
    <path
      d="M11 13.5H9.5C9.36739 13.5 9.24021 13.4473 9.14645 13.3536C9.05268 13.2598 9 13.1326 9 13V3C9 2.86739 9.05268 2.74021 9.14645 2.64645C9.24021 2.55268 9.36739 2.5 9.5 2.5H11C11.1326 2.5 11.2598 2.55268 11.3536 2.64645C11.4473 2.74021 11.5 2.86739 11.5 3V13C11.5 13.1326 11.4473 13.2598 11.3536 13.3536C11.2598 13.4473 11.1326 13.5 11 13.5Z"
      fill="currentColor"
    />
  </svg>
);

export const RestartIcon = ({ className }) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M8 14.5C4.41594 14.5 1.5 11.5841 1.5 8C1.5 4.41594 4.41594 1.5 8 1.5C11.5841 1.5 14.5 4.41594 14.5 8C14.5 11.5841 11.5841 14.5 8 14.5Z"
      fill="currentColor"
    />
  </svg>
);
